import { createSlice } from "@reduxjs/toolkit";

const orgListSlice = createSlice({
  name: "orgList",
  initialState: {
    organizations: [],
    isLoaded: false,
    isLoading: false,
    lastFetchTime: null,
    error: null,
  },
  reducers: {
    // Start loading organizations
    fetchOrgListStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },

    // Successfully loaded organizations
    fetchOrgListSuccess: (state, action) => {
      state.organizations = action.payload;
      state.isLoaded = true;
      state.isLoading = false;
      state.lastFetchTime = Date.now();
      state.error = null;
    },

    // Failed to load organizations
    fetchOrgListFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Clear organization list (for logout)
    clearOrgList: (state) => {
      state.organizations = [];
      state.isLoaded = false;
      state.isLoading = false;
      state.lastFetchTime = null;
      state.error = null;
    },

    // Force refresh flag
    invalidateOrgList: (state) => {
      state.isLoaded = false;
    },
  },
});

export const {
  fetchOrgListStart,
  fetchOrgListSuccess,
  fetchOrgListFailure,
  clearOrgList,
  invalidateOrgList,
} = orgListSlice.actions;

// Selectors
export const selectOrgList = (state) => state.orgList.organizations;
export const selectIsOrgListLoaded = (state) => state.orgList.isLoaded;
export const selectIsOrgListLoading = (state) => state.orgList.isLoading;
export const selectOrgListError = (state) => state.orgList.error;
export const selectOrgListLastFetchTime = (state) =>
  state.orgList.lastFetchTime;

export default orgListSlice.reducer;
